import {EventName} from "./types";
import {EVENT_NAMES} from "./eventNames";

export const OVERRIDES: Partial<Record<EventName, EventName[]>> = {
    [EVENT_NAMES.FORM_SUBMIT]: [EVENT_NAMES.BUTTON_CLICK],
    [EVENT_NAMES.NAVIGATION]: [EVENT_NAMES.BUTTON_CLICK],
    [EVENT_NAMES.META_NAVIGATION]: [EVENT_NAMES.BUTTON_CLICK],
    [EVENT_NAMES.BREADCRUMB]: [EVENT_NAMES.BUTTON_CLICK],
    [EVENT_NAMES.TOPIC_NAVIGATION]: [EVENT_NAMES.BUTTON_CLICK],
    [EVENT_NAMES.CLICK_LOGO]: [EVENT_NAMES.BUTTON_CLICK],
    [EVENT_NAMES.OUTBOUND]: [EVENT_NAMES.BUTTON_CLICK],
    [EVENT_NAMES.TEASERCARD_SELECT]: [EVENT_NAMES.BUTTON_CLICK, EVENT_NAMES.OUTBOUND],
};

export const DEFAULT_ELEMENT_LOCATION = "Main Content";

export const ELEMENT_LOCATION_RULES = [
    {
        location: "Header",
        selector: 'header,[role="banner"],#navigation,[data-cypress="appBar"],' +
                  '[data-cypress="topNavi"]',
    },
    {
        location: "Footer",
        selector: 'footer,[role="contentinfo"],#footer,[data-cypress="footer"]',
    },
] as const;
